<template>
  <article id="AppLoader"></article>
</template>

<style lang="scss">
#AppLoader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--main-color);
    z-index: 100;

    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
        content:'';
        border: 3px solid var(--light-grey);
        border-top: 3px solid var(--secondary-color);
        border-radius: 50%;
        width: 120px;
        height: 120px;
        animation: spin 2s var(--tk-easeinout) infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>